export const getMonitoreoDashboardTemplate = (images, info) => {

    const COLORS = {
        primary: '#1e293b',
        secondary: '#64748b',
        border: '#cbd5e1',
        bgPanel: '#f8fafc',
        red: '#dc2626',
        blue: '#2563eb',
        blueHighlight: '#eff6ff',
    };

    const DIMS = {
        gap: 15,
        kpiW: 210, // Para filas de 5 columnas
        kpiH: 110,
        chartW: 547, // Para filas de 2 columnas (1110 - 15) / 2
        chartH: 330
    };

    const createCleanCard = (imageKey, height, width, leftBorderColor = null, innerMargin = 4) => {
        const imageBase64 = images[imageKey];

        const canvasElements = [
            { type: 'rect', x: 0, y: 0, w: width, h: height, r: 6, lineColor: COLORS.border, lineWidth: 1, color: '#ffffff' }
        ];

        if (leftBorderColor) {
            canvasElements.push({
                type: 'rect', x: 0, y: 0, w: 5, h: height, r: 0, color: leftBorderColor, lineColor: leftBorderColor
            });
        }

        return {
            stack: [
                { canvas: canvasElements },
                {
                    margin: [0, -height, 0, 0],
                    table: {
                        widths: [width],
                        heights: [height],
                        body: [
                            [
                                {
                                    stack: [
                                        imageBase64 ? {
                                            image: imageBase64,
                                            fit: [width - innerMargin, height - innerMargin],
                                            alignment: 'center',
                                        } : {
                                            text: 'Sin datos / Cargando...', style: 'muted', alignment: 'center', margin: [0, height / 2.5, 0, 0]
                                        }
                                    ],
                                    verticalAlign: 'middle',
                                    border: [false, false, false, false],
                                }
                            ]
                        ]
                    },
                    layout: 'noBorders'
                }
            ],
            unbreakable: true
        };
    };

    const createSectionTitle = (title, color) => ({
        columns: [
            { canvas: [{ type: 'rect', x: 0, y: 4, w: 8, h: 8, r: 4, color: color }], width: 15 },
            { text: title, style: 'sectionTitle' }
        ],
        margin: [0, 15, 0, 8]
    });

    const buildFiltersAnnex = (filtros) => {
        if (!filtros || filtros.length === 0) return { text: 'No se aplicaron filtros.', style: 'muted' };

        const tableBody = [];
        for (let i = 0; i < filtros.length; i += 3) {
            const row = [
                renderFiltro(filtros[i]),
                renderFiltro(filtros[i + 1]),
                renderFiltro(filtros[i + 2])
            ];
            tableBody.push(row);
        }

        return {
            table: { widths: ['*', '*', '*'], body: tableBody },
            layout: 'noBorders',
            margin: [0, 10, 0, 0]
        };
    };

    const renderFiltro = (filtro) => {
        if (!filtro) return { text: '' };
        return {
            stack: [
                { text: filtro.label.toUpperCase(), fontSize: 7, bold: true, color: COLORS.secondary, margin: [0, 0, 0, 2] },
                { text: String(filtro.value), fontSize: 9, color: COLORS.primary }
            ],
            margin: [0, 0, 10, 15]
        };
    };

    const spacerFila3Items = (1110 - (DIMS.kpiW * 3 + DIMS.gap * 2)) / 2;
    const spacerFila1Item = (1110 - DIMS.chartW) / 2;

    return {
        pageSize: 'A3',
        pageOrientation: 'landscape',
        pageMargins: [40, 85, 40, 30],

        header: {
            margin: [40, 20, 40, 0],
            columns: [
                {
                    width: 65,
                    ...(info.logo ? { image: info.logo, width: 55, alignment: 'left' } : { text: '' })
                },
                {
                    width: '*',
                    stack: [
                        { text: info.empresa, style: 'brandText' },
                        {
                            text: 'Dashboard de Monitoreo',
                            style: 'headerMeta',
                            bold: true,
                            color: COLORS.primary,
                            margin: [0, 1, 0, 4]
                        },
                        {
                            text: [
                                { text: `Empresa: ${info.empresaSeleccionada}  |  Matriz: ${info.matrizSeleccionada}`, style: 'contextText' },
                                { text: `  |  Filtros Aplicados: ${info.totalFiltros}`, color: COLORS.secondary, bold: true, fontSize: 10 }
                            ]
                        }
                    ]
                },
                {
                    width: 'auto',
                    stack: [
                        { text: `Fecha de Generación: ${info.fechaGeneracion}`, style: 'headerMeta', alignment: 'right' },
                        { text: `Usuario: ${info.nombre_usuario}`, style: 'headerMeta', alignment: 'right', margin: [0, 2, 0, 0] }
                    ]
                }
            ]
        },

        footer: (currentPage, pageCount) => ({
            columns: [
                { text: 'Generado desde el Módulo de Monitoreo', style: 'footerText' },
                { text: `Página ${currentPage} de ${pageCount}`, style: 'footerText', alignment: 'right' }
            ],
            margin: [40, 10, 40, 0]
        }),

        content: [
            createSectionTitle('COMPORTAMIENTO PERFIL TRANSACCIONAL', COLORS.red),
            // Fila 1: 5 KPIs Principales
            {
                columns: [
                    createCleanCard('kpi-riesgo-0', DIMS.kpiH, DIMS.kpiW, info.coloresKpisPrincipales[0]), { width: DIMS.gap, text: '' },
                    createCleanCard('kpi-riesgo-1', DIMS.kpiH, DIMS.kpiW, info.coloresKpisPrincipales[1]), { width: DIMS.gap, text: '' },
                    createCleanCard('kpi-riesgo-2', DIMS.kpiH, DIMS.kpiW, info.coloresKpisPrincipales[2]), { width: DIMS.gap, text: '' },
                    createCleanCard('kpi-riesgo-3', DIMS.kpiH, DIMS.kpiW, info.coloresKpisPrincipales[3]), { width: DIMS.gap, text: '' },
                    createCleanCard('kpi-riesgo-4', DIMS.kpiH, DIMS.kpiW, info.coloresKpisPrincipales[4])
                ],
                margin: [0, 0, 0, DIMS.gap]
            },
            // Fila 2: 3 KPIs Demográficos Centrados
            {
                columns: [
                    { width: spacerFila3Items, text: '' }, // Spacer izquierdo
                    createCleanCard('kpi-centrado-0', DIMS.kpiH, DIMS.kpiW, info.coloresKpisDemograficos[0]), { width: DIMS.gap, text: '' },
                    createCleanCard('kpi-centrado-1', DIMS.kpiH, DIMS.kpiW, info.coloresKpisDemograficos[1]), { width: DIMS.gap, text: '' },
                    createCleanCard('kpi-centrado-2', DIMS.kpiH, DIMS.kpiW, info.coloresKpisDemograficos[2]),
                    { width: spacerFila3Items, text: '' }  // Spacer derecho
                ],
                margin: [0, 0, 0, 20]
            },

            // Otros indicadores
            createSectionTitle('OTROS INDICADORES', COLORS.blue),
            // Fila 3: Mapa Choropleth (Izq) y Barras (Der)
            {
                columns: [
                    createCleanCard('mapa-principal', DIMS.chartH, DIMS.chartW),
                    { width: DIMS.gap, text: '' },
                    createCleanCard('barras-principal', DIMS.chartH, DIMS.chartW)
                ],
                margin: [0, 0, 0, DIMS.gap]
            },
            // Salto de página
            { text: '', pageBreak: 'before' },
            // Fila 4: Pie Chart Centrado
            {
                columns: [
                    { width: spacerFila1Item, text: '' },
                    createCleanCard('pie-chart', DIMS.chartH, DIMS.chartW),
                    { width: spacerFila1Item, text: '' }
                ],
                margin: [0, 0, 0, 30]
            },

            // ANEXO: Filtros aplicados
            createSectionTitle('ANEXO: FILTROS DE BÚSQUEDA APLICADOS', COLORS.secondary),
            {
                text: 'A continuación se listan los parámetros de búsqueda aplicados para este reporte:',
                fontSize: 10, color: COLORS.secondary, margin: [0, 0, 0, 5]
            },
            buildFiltersAnnex(info.filtrosAplicados)
        ],

        // Estilos Globales
        styles: {
            brandText: { fontSize: 16, bold: true, color: COLORS.primary, margin: [0, 0, 0, 2] },
            headerMeta: { fontSize: 10, color: COLORS.secondary },
            contextText: { fontSize: 10, bold: true, color: COLORS.blue, background: COLORS.blueHighlight },
            sectionTitle: { fontSize: 11, bold: true, color: COLORS.primary, characterSpacing: 0.5 },
            muted: { fontSize: 9, color: COLORS.secondary, italics: true },
            footerText: { fontSize: 9, color: COLORS.secondary }
        },
        defaultStyle: { font: 'Roboto' }
    };
};